export default "__VITE_ASSET__DOONjvie__"